<template>
    <div class="placeholder-image"
        :class="rootClass"
        :style="wrapperVars">
        <svg-icon
            :name="iconName"
            :style="iconVars"
            class="placeholder-image__icon"/>
    </div>
</template>

<script>
export default {
    name: "PlaceholderImage",
    props: {
        iconName: {
            type: String,
            default: 'placeholder-photo'
        },
        isCircle: {
            type: Boolean,
            default: false
        },
        placeholderSize: {
            type: String,
            default: '40'
        },
        iconSize: {
            type: String,
            default: '20'
        }
    },
    computed: {
        rootClass() {
            return this.isCircle ? 'placeholder-image_circle' : ''
        },
        iconVars() {
            return {
                '--sizeIcon': (this.iconSize / 15).toFixed(7) + 'rem',
            }
        },
        wrapperVars() {
            return {
                '--sizeWrapper': (this.placeholderSize / 15).toFixed(7) + 'rem',
            }
        }
    }
};
</script>

<style lang="less">
.placeholder-image {
    display: flex;
    align-items: center;
    justify-content: center;

    background-color: @color-gray-light-2;

    height: var(--sizeWrapper);
    width: var(--sizeWrapper);

    position: relative;

    &__icon {
        height: var(--sizeIcon);
        width: var(--sizeIcon);
        max-height: 100%;
        max-width: 100%;
    }

    &_circle {
        border-radius: 50%;
    }
}
</style>
